module.exports = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\"><title>close-icon</title><path d=\"M18 0L0 18M0 0l18 18\" stroke-width=\"2.1\" stroke=\"#FFF\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/icons/close-icon.svg
// module id = ./node_modules/raw-loader/index.js!./src/icons/close-icon.svg
// module chunks = 168707334958949